import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="compra" className="bg-navy-light py-16 md:py-24 px-4 scroll-mt-10" data-id="element-50">
      <div className="max-w-4xl mx-auto" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-52">
          <div className="bg-navy-dark p-8 md:p-12 rounded-3xl border-2 border-gold shadow-[0_0_50px_rgba(201,168,76,0.15)] relative overflow-hidden" data-id="element-53">
            {/* Shine effect */}
            <div className="absolute top-0 -left-[100%] w-1/2 h-full bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-12 animate-[shine_8s_infinite]" data-id="element-54"></div>

            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-55">
              La promesa es simple
            </h2>

            <p className="text-xl md:text-2xl text-gray-300 mb-8" data-id="element-56">
              Podés transformar tu estudio jurídico en un sistema organizado,
              eficiente y escalable…
            </p>

            <p className="text-3xl md:text-4xl font-black text-gold mb-12" data-id="element-57">
              👉 En menos de 7 días.
            </p>

            <div className="space-y-4 text-lg text-gray-400 mb-12" data-id="element-58">
              <p data-id="element-59">Sin software complicado. Sin procesos eternos.</p>
              <p data-id="element-60">Porque el problema nunca fue tu capacidad</p>
              <div className="bg-navy-light py-6 px-4 rounded-xl inline-block mt-4 border border-red-500/20" data-id="element-61">
                <p className="text-white font-bold mb-4" data-id="element-62">Fue esto:</p>
                <ul className="space-y-2 text-left inline-block" data-id="element-63">
                  <li className="flex items-center gap-2" data-id="element-64">
                    <span className="text-gold" data-id="element-65">👉</span> Falta de estructura
                  </li>
                  <li className="flex items-center gap-2" data-id="element-66">
                    <span className="text-gold" data-id="element-67">👉</span> Falta de procesos
                  </li>
                  <li className="flex items-center gap-2" data-id="element-68">
                    <span className="text-gold" data-id="element-69">👉</span> Falta de sistema
                  </li>
                </ul>
              </div>
            </div>

            <div className="border-t border-gray-800 pt-12 mb-12" data-id="element-70">
              <img src="https://cdn.magicpatterns.com/uploads/fy79wuSYUogRN224kaC9Zw/MOCKUP_PNG.png" alt="Estudio Jurídico Listo" className="w-full max-w-md mx-auto mb-8 drop-shadow-2xl" data-id="element-71" />

              <div className="mb-8" data-id="element-72">
                <p className="text-gray-400 text-lg mb-2" data-id="element-73">Precio Regular:</p>
                <p className="text-3xl text-red-500 line-through font-bold mb-2" data-id="element-74">
                  $49.990
                </p>
                <p className="text-gray-300 text-sm uppercase tracking-widest mb-4" data-id="element-75">
                  Precio Especial Hoy
                </p>
                <p className="text-6xl md:text-7xl font-black text-gold drop-shadow-[0_0_10px_rgba(201,168,76,0.5)]" data-id="element-76">
                  $19.990
                </p>
                <p className="text-sm text-gray-400 mt-2" data-id="element-77">
                  Pago único. Acceso de por vida.
                </p>
              </div>

              <CTAButton className="w-full md:w-auto text-xl py-5 px-10" data-id="element-78" />

              <div className="mt-6 flex items-center justify-center gap-4 text-sm text-gray-400" data-id="element-79">
                <span className="flex items-center gap-1" data-id="element-80">
                  🔒 Pago 100% Seguro
                </span>
                <span data-id="element-81">•</span>
                <span className="flex items-center gap-1" data-id="element-82">
                  ⚡ Acceso Inmediato
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}